<template>
  <q-btn
    :to="{ name: 'New Property Report', query: { propertyId: propertyId } }"
    dense
    unelevated
    color="primary"
    size="xs"
    style="margin-bottom: 5px"
    class="q-ml-xs"
  >
    <q-icon name="post_add" />
    <q-tooltip> Create new report for this property </q-tooltip>
  </q-btn>
</template>

<script lang="ts">
export default {
  name: 'NewPropertyReportIcon',
  props: {
    propertyId: {
      type: String,
      required: true
    }
  }
}
</script>
